// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';

// // Import translations
// import translationEN from './locales/en/translation.json'; // English
// import translationFR from './locales/fr/translation.json'; // French (example)
// const resources = {
//   en: {
//     translation: translationEN,
//   },
//   fr: {
//     translation: translationFR,
//   },
// };
// i18n.use(initReactI18next).init({
//   resources,
//   lng: 'en', // Set the default language
//   keySeparator: false, // Allow for nested translations without using dots
//   interpolation: {
//     escapeValue: false,
//   },
// });
// export default i18n;


import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HTTPApi from "i18next-http-backend";

import translationEN from './locales/en/translation.json'; 
import translationFR from './locales/fr/translation.json';
const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HTTPApi)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;